import { Link } from "react-router-dom";

const LOGO_URL = "https://nautiqo.cloud/logo-nautiqo.png";
const heading = { fontFamily: "'Cabinet Grotesk', 'Outfit', sans-serif" };

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Manrope', sans-serif" }}>
      {/* Nav */}
      <nav className="border-b border-slate-200 bg-white sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/landing" className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-[22%] overflow-hidden flex-shrink-0"><img src={LOGO_URL} alt="Nautiqo" className="w-full h-full scale-[1.06]" /></div>
            <span className="font-bold text-xl text-slate-900 tracking-tight" style={heading}>Nautiqo</span>
          </Link>
          <Link to="/landing" className="text-slate-500 hover:text-slate-900 text-sm font-medium transition-colors">
            Torna alla home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12 sm:py-16">
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight mb-2" style={heading}>
          Informativa sulla Privacy
        </h1>
        <p className="text-slate-500 mb-10">Ultimo aggiornamento: 18 aprile 2026</p>

        <div className="prose prose-slate max-w-none space-y-8 text-slate-700 leading-relaxed">

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>1. Titolare del trattamento</h2>
            <p>
              L'applicazione <strong>Nautiqo</strong> e sviluppata e gestita da Nautiqo.<br />
              Per qualsiasi richiesta relativa alla privacy, e possibile contattarci all'indirizzo email: <a href="mailto:info@nautiqo.cloud" className="text-blue-600 hover:underline">info@nautiqo.cloud</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>2. Dati raccolti</h2>
            <p>Nautiqo raccoglie i seguenti dati per garantire il funzionamento del servizio:</p>
            <h3 className="text-lg font-semibold text-slate-800 mt-4 mb-2">Dati forniti dall'utente</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Nome e cognome</li>
              <li>Indirizzo email</li>
              <li>Numero di telefono</li>
              <li>Nome dell'attivita (azienda/charter)</li>
              <li>Informazioni sulle barche (nome, modello, capacita, porto di partenza, prezzi)</li>
              <li>Dati delle prenotazioni (date, clienti, importi)</li>
              <li>Foto delle barche (se caricate dall'utente)</li>
            </ul>
            <h3 className="text-lg font-semibold text-slate-800 mt-4 mb-2">Dati raccolti automaticamente</h3>
            <ul className="list-disc pl-6 space-y-1">
              <li>Token di autenticazione per l'accesso sicuro</li>
              <li>Token per notifiche push (se autorizzate dall'utente)</li>
              <li>Data e ora di registrazione e ultimo accesso</li>
              <li>Indirizzo IP (per motivi di sicurezza)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>3. Finalita del trattamento</h2>
            <p>I dati personali vengono trattati per le seguenti finalita:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Creazione e gestione dell'account utente</li>
              <li>Gestione delle prenotazioni e del calendario disponibilita</li>
              <li>Gestione della flotta (barche, prezzi, disponibilita)</li>
              <li>Elaborazione dei pagamenti tramite Stripe</li>
              <li>Invio di notifiche push relative a prenotazioni e attivita</li>
              <li>Invio di comunicazioni email transazionali (conferme, promemoria)</li>
              <li>Generazione di report e statistiche per l'operatore</li>
              <li>Funzionamento del link di prenotazione pubblico</li>
              <li>Gestione del trial e degli abbonamenti</li>
              <li>Sicurezza e prevenzione di accessi non autorizzati</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>4. Servizi di terze parti</h2>
            <p>Nautiqo utilizza i seguenti servizi esterni per il funzionamento della piattaforma:</p>
            <div className="overflow-x-auto mt-3">
              <table className="w-full text-sm border border-slate-200 rounded-xl overflow-hidden">
                <thead>
                  <tr className="bg-slate-50">
                    <th className="text-left px-4 py-3 font-semibold text-slate-700">Servizio</th>
                    <th className="text-left px-4 py-3 font-semibold text-slate-700">Scopo</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  <tr><td className="px-4 py-3 font-medium">Stripe</td><td className="px-4 py-3">Elaborazione pagamenti online e gestione acconti</td></tr>
                  <tr><td className="px-4 py-3 font-medium">Resend</td><td className="px-4 py-3">Invio email transazionali (conferme prenotazione, promemoria)</td></tr>
                  <tr><td className="px-4 py-3 font-medium">Firebase Cloud Messaging</td><td className="px-4 py-3">Invio notifiche push</td></tr>
                  <tr><td className="px-4 py-3 font-medium">Cloudflare</td><td className="px-4 py-3">Hosting, CDN e protezione DDoS</td></tr>
                  <tr><td className="px-4 py-3 font-medium">Apple App Store</td><td className="px-4 py-3">Distribuzione dell'app per iOS</td></tr>
                  <tr><td className="px-4 py-3 font-medium">Google Play Store</td><td className="px-4 py-3">Distribuzione dell'app per Android</td></tr>
                </tbody>
              </table>
            </div>
            <p className="mt-3">
              Ciascun servizio di terze parti opera secondo le proprie informative sulla privacy.
              Si consiglia di consultare le rispettive policy per maggiori dettagli.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>5. Permessi dell'applicazione</h2>
            <p>L'app Nautiqo puo richiedere i seguenti permessi sul dispositivo:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Notifiche push</strong> — Per informare in tempo reale su nuove prenotazioni, conferme, promemoria e comunicazioni dall'operatore. Il permesso e facoltativo e puo essere revocato in qualsiasi momento dalle impostazioni del dispositivo.</li>
              <li><strong>Fotocamera</strong> — Per scattare foto delle barche da caricare nel profilo. Il permesso viene richiesto solo quando l'utente utilizza la funzione di upload foto.</li>
              <li><strong>Galleria/File</strong> — Per selezionare immagini esistenti da caricare come foto delle barche. Il permesso viene richiesto solo al momento dell'upload.</li>
            </ul>
            <p className="mt-2">
              Nessun permesso viene concesso automaticamente. Ogni permesso e richiesto esplicitamente all'utente e puo essere revocato in qualsiasi momento tramite le impostazioni del dispositivo.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>6. Conservazione dei dati</h2>
            <p>
              I dati personali vengono conservati per tutto il periodo in cui l'account dell'utente risulta attivo.
              In caso di cancellazione dell'account, tutti i dati personali associati vengono eliminati in modo permanente
              entro 30 giorni dalla richiesta, salvo obblighi di legge che ne richiedano la conservazione per periodi piu lunghi.
            </p>
            <p className="mt-2">
              I dati delle prenotazioni possono essere conservati in forma anonimizzata per finalita statistiche.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>7. Sicurezza</h2>
            <p>Nautiqo adotta le seguenti misure di sicurezza per proteggere i dati degli utenti:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Comunicazioni crittografate tramite protocollo HTTPS/TLS</li>
              <li>Autenticazione tramite token JWT con scadenza</li>
              <li>Password memorizzate con hashing sicuro (bcrypt)</li>
              <li>Accesso ai dati limitato in base al ruolo (operatore, staff, admin)</li>
              <li>Protezione contro attacchi DDoS tramite Cloudflare</li>
              <li>Monitoraggio continuo dell'infrastruttura</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>8. Diritti dell'utente</h2>
            <p>In conformita con il Regolamento Generale sulla Protezione dei Dati (GDPR), l'utente ha diritto a:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Accesso</strong> — Richiedere copia dei propri dati personali</li>
              <li><strong>Rettifica</strong> — Correggere dati inesatti o incompleti</li>
              <li><strong>Cancellazione</strong> — Richiedere l'eliminazione dei propri dati personali</li>
              <li><strong>Portabilita</strong> — Ricevere i propri dati in un formato strutturato e leggibile</li>
              <li><strong>Opposizione</strong> — Opporsi al trattamento dei dati per motivi legittimi</li>
              <li><strong>Revoca del consenso</strong> — Revocare il consenso al trattamento in qualsiasi momento</li>
            </ul>
            <p className="mt-3">
              Per esercitare i propri diritti, e sufficiente inviare una richiesta all'indirizzo: <a href="mailto:info@nautiqo.cloud" className="text-blue-600 hover:underline">info@nautiqo.cloud</a>
            </p>
            <p className="mt-2">
              La richiesta verra elaborata entro 30 giorni dalla ricezione.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>9. Modifiche alla presente informativa</h2>
            <p>
              Nautiqo si riserva il diritto di aggiornare la presente informativa sulla privacy in qualsiasi momento.
              In caso di modifiche sostanziali, gli utenti saranno informati tramite notifica nell'app o comunicazione email.
            </p>
            <p className="mt-2">
              La data dell'ultimo aggiornamento e sempre indicata in cima a questa pagina.
              L'uso continuato del servizio dopo la pubblicazione delle modifiche costituisce accettazione della nuova informativa.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3" style={heading}>10. Contatti</h2>
            <p>
              Per qualsiasi domanda o richiesta relativa alla privacy e al trattamento dei dati personali:
            </p>
            <div className="bg-slate-50 rounded-xl p-4 mt-3">
              <p className="font-semibold text-slate-900">Nautiqo</p>
              <p>Email: <a href="mailto:info@nautiqo.cloud" className="text-blue-600 hover:underline">info@nautiqo.cloud</a></p>
              <p>Sito web: <a href="https://nautiqo.cloud" className="text-blue-600 hover:underline">nautiqo.cloud</a></p>
            </div>
          </section>

        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-slate-200 py-8 mt-12">
        <div className="max-w-4xl mx-auto px-4 text-center text-sm text-slate-500 space-y-2">
          <p className="leading-relaxed">
            <span className="font-medium text-slate-700">Titolare del trattamento:</span>{" "}
            Seawave S.a.s. di Laudicina Marco &amp; C. · P.IVA <span className="select-all">02855570814</span><br />
            Email: <a href="mailto:info@nautiqo.cloud" className="hover:text-slate-900 select-all">info@nautiqo.cloud</a>
          </p>
          <p>&copy; {new Date().getFullYear()} Nautiqo. Tutti i diritti riservati.</p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPage;
